import { useState } from "react";
import { Button } from "@/components/base/buttons/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { stopEscapePropagation } from "./composer-toolbar";
import { DEFAULT_TEMPLATE_CATEGORY, TemplateDetailsFields, TemplateDialogHeader } from "./template-details";

type SaveAsTemplateDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  categories: string[];
  isSaving: boolean;
  onSave: (input: { name: string; category: string }) => Promise<boolean>;
  portalContainer?: HTMLElement | null;
};

export function SaveAsTemplateDialog({
  open,
  onOpenChange,
  categories,
  isSaving,
  onSave,
  portalContainer,
}: SaveAsTemplateDialogProps) {
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");

  const close = () => {
    setName("");
    setCategory("");
    onOpenChange(false);
  };

  const save = async () => {
    const saved = await onSave({ name: name.trim(), category: category.trim() || DEFAULT_TEMPLATE_CATEGORY });
    if (saved) close();
  };

  return (
    <Dialog open={open} onOpenChange={(next) => (next ? onOpenChange(true) : close())}>
      <DialogContent
        hideCloseButton
        portalContainer={portalContainer}
        onKeyDown={stopEscapePropagation}
        aria-describedby={undefined}
        className="z-[130] gap-6 rounded-2xl border-none bg-primary p-7 sm:max-w-[520px] sm:rounded-2xl"
      >
        <TemplateDialogHeader title="Save as new Template" onClose={close} />
        <TemplateDetailsFields
          name={name}
          onNameChange={setName}
          category={category}
          onCategoryChange={setCategory}
          categories={categories}
          nameLabel="Template name"
          labelClassName="text-sm font-medium text-secondary"
          autoFocusName
        />
        <div className="flex justify-end gap-3">
          <Button color="secondary" onClick={close}>
            Cancel
          </Button>
          <Button isDisabled={!name.trim()} isLoading={isSaving} onClick={save}>
            Save Template
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
